import { Divider, Flex, VStack, Box, Text } from '@cad-arc';
import { format } from 'date-fns';
import { HospitalStatusTag } from '../../../../common/components/hospital-status-tag';
import { CommonSize, getOneSizeSmaller } from '../../../../common/helpers/utils';

type HospitalStatusSectionProps = {
    status?: string;
    statusGlobalAttributeId?: number;
    lastUpdatedDateUtc?: string;
    capabilities?: string[];
    notes?: string;
    size?: CommonSize;
};

export function HospitalStatusSection({
    status,
    statusGlobalAttributeId,
    lastUpdatedDateUtc,
    capabilities,
    notes,
    size,
}: HospitalStatusSectionProps): React.ReactElement {
    const smallerSize = getOneSizeSmaller(size);

    return (
        <Box data-testid="MAP_HOSPITAL_STATUS_SECTION">
            <Flex padding="12px 18px" gap={2}>
                <VStack spacing={3} width="100%">
                    <VStack width="100%" alignItems="baseline" spacing={1}>
                        <Text fontSize={smallerSize}>Status</Text>
                        <HospitalStatusTag
                            hospitalStatusGlobalAttributeId={statusGlobalAttributeId}
                            hospitalStatus={status}
                            size={size}
                        />
                        {lastUpdatedDateUtc && (
                            <Text fontSize={smallerSize}>
                                Last updated {format(new Date(lastUpdatedDateUtc), 'HH:mm MM/dd/y')}
                            </Text>
                        )}
                    </VStack>
                    {capabilities && capabilities.length > 0 && (
                        <VStack width="100%" alignItems="baseline">
                            <Text fontSize={smallerSize}>Capabilities</Text>
                            <Flex direction="column">
                                {capabilities.map((capability, index) => (
                                    <Text
                                        key={index}
                                        fontSize={size}
                                        style={{
                                            wordBreak: 'break-word',
                                            display: 'list-item',
                                            listStylePosition: 'inside',
                                            paddingLeft: 10,
                                        }}
                                    >
                                        {capability}
                                    </Text>
                                ))}
                            </Flex>
                        </VStack>
                    )}
                    {notes && (
                        <VStack width="100%" alignItems="baseline">
                            <Text fontSize={smallerSize}>Notes</Text>
                            <Text fontSize={size} style={{ wordBreak: 'break-word' }}>
                                {notes}
                            </Text>
                        </VStack>
                    )}
                </VStack>
            </Flex>
            <Divider />
        </Box>
    );
}
